import Card from 'components/Layout/Card';
import React, { useState } from 'react'
import { getCountryCode, titleCaseString } from 'utils/helpers';
import ResearchInformation from './ResearchInformation';
import { dialCode, icons } from 'utils/constants';
import Button from 'components/form/Button';
import { useSelector } from 'react-redux';


const ReviewAbstract = ({ onBack, onNext, btnLoading, eventData }) => {
    const reduxData = useSelector((state) => state.aiAbstractSubmission);
    const { aiAbstractData } = reduxData || {};

    const {
        title,
        paperId,
        memberId,
        department,
        keywords,
        author_name,
        co_authors,
        author_email,
        whatsapp_number,
        whatsapp_country_code,
        contact_number,
        contact_country_code,
        country_name,
        submission_type,
        designation,
        presentation_type,
        abstract,
        speaker_details,
        add_on_services,
        submission_category,
        author_orcid_id,
        author_scopus_id,
    } = aiAbstractData;

    const [isExpanded, setIsExpanded] = useState(false);
    const maxWords = 70;
    const abstractText = abstract
        ?.replace(/<\/?p>/g, "")
        ?.replace(/<\/?span[^>]*>/g, "")
        ?.trim();
    const abstractWords = abstractText?.split(" ")?.filter((word) => word);
    const toggleReadMore = () => {
        setIsExpanded((prev) => !prev);
    };
    const speakers = [
        {
            name: "Prof. Maria Andersen",
            title: "Reimagining Universal Design for Future Classrooms",
            label: "Recommended"
        },
        {
            name: "Dr. Leonard Mills",
            title: "Bridging Accessibility Gaps in Remote Education",
            label: "Highly Relevant"
        }
    ];
    return (
        <>
            <Card >
                <div className="cp-20">
                    <div className='text-16-400-20 color-a35b cmb-30'>
                        Review Your Submission
                    </div>
                    <div className="row custom-border-bottom gx-0 cpb-10 normal-screen-header">
                        <div className="col-lg-8">
                            <h2 className="text-16-400-20 color-new-car">
                                Conference & Abstract Info :
                            </h2>
                        </div>
                        <div className="col-lg-4 cps-20">
                            <h2 className="text-16-400-20 color-new-car">
                                Author’s & Contact Info :
                            </h2>
                        </div>
                    </div>
                    <div className="row gx-lg-0">
                        <div className="col-lg-8  cpt-21 custom-border-end" >
                            <h2 className="text-16-400-20 color-new-car cpb-10 mobile-screen-header">
                                Conference & Abstract Info :
                            </h2>
                            {eventData?.event_name && (
                                <>
                                    <div className="text-14-400-17 color-new-car">
                                        Conference Name:
                                    </div>
                                    <p className="text-14-300-24 color-black-olive cmb-20">
                                        {titleCaseString(eventData?.event_name)}
                                    </p>
                                </>
                            )}
                            {title && (
                                <>
                                    <div className="text-14-400-17 color-new-car">Paper Title:</div>
                                    <p className="text-14-300-24 color-black-olive cmb-20">
                                        {titleCaseString(title)}
                                    </p>
                                </>
                            )}
                            <div className="row cmb-20 gy-3">
                                {paperId && (
                                    <div className="col-lg-6">
                                        <div className="text-14-400-17 color-new-car">Paper ID:</div>
                                        <span className="text-14-300-24 color-black-olive">
                                            {paperId}
                                        </span>
                                    </div>
                                )}
                                {memberId && (
                                    <div className="col-lg-6">
                                        <div className="text-14-400-17 color-new-car">Member ID:</div>
                                        <span className="text-14-300-24 color-black-olive">
                                            {memberId}
                                        </span>
                                    </div>
                                )}
                            </div>

                            {keywords?.length > 0 && (
                                <div className="d-flex align-items-center gap-4">
                                    <div className="text-14-400-17 color-new-car">Keywords:</div>
                                    <div className="d-flex align-items-center gap-2 flex-wrap">
                                        {keywords?.map((words, index) => {
                                            return (
                                                <span
                                                    key={index}
                                                    className="bg-f4ff color-new-car cps-8 cpe-8 cpt-2 cpb-2 br-2 text-14-400-17"
                                                >
                                                    {words}
                                                </span>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                            <div className="row cmt-20">
                                {department && (
                                    <div className="col-lg-4">
                                        <div className="text-14-400-17 color-new-car">Department :</div>
                                        <div className="d-flex align-items-center gap-2 flex-wrap">
                                            <span className="text-14-300-24 color-black-olive">
                                                {department}
                                            </span>
                                        </div>
                                    </div>
                                )}
                                {designation && (
                                    <div className="col-lg-4">
                                        <div className="text-14-400-17 color-new-car">Designation :</div>
                                        <div className="d-flex align-items-center gap-2 flex-wrap">
                                            <span className="text-14-300-24 color-black-olive">
                                                {department}
                                            </span>
                                        </div>
                                    </div>
                                )}
                                {presentation_type && (
                                    <div className="col-lg-4 cmb-20">
                                        <div className="text-14-400-17 color-new-car">Presentation Type :</div>
                                        <div className="d-flex align-items-center gap-2 flex-wrap">
                                            <span className="text-14-300-24 color-black-olive">
                                                {presentation_type}
                                            </span>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="row cmt-20">

                                {submission_category && (
                                    <div className="col-lg-6">
                                        <div className="text-14-400-17 color-new-car">
                                            Choose your submission type to proceed :
                                        </div>
                                        <p className="text-14-300-24 color-black-olive">
                                            {titleCaseString(submission_category)}
                                        </p>
                                    </div>
                                )}


                                <div className="col-lg-3">
                                    <div className="text-14-400-17 color-new-car">
                                        ORCID ID :
                                    </div>
                                    <p className="text-14-300-24 color-black-olive">
                                        {author_orcid_id || '-'}
                                    </p>
                                </div>

                                <div className="col-lg-3">
                                    <div className="text-14-400-17 color-new-car">
                                        Scopus Id:
                                    </div>
                                    <p className="text-14-300-24 color-black-olive">
                                        {author_scopus_id || '-'}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 custom-padding">
                            <h2 className="text-16-400-20 color-new-car cpb-10 mobile-screen-header">
                                Author’s & Contact Info :
                            </h2>
                            <div className="d-flex align-items-center gap-2 cmb-20">
                                {author_name && (
                                    <>
                                        <div className="text-14-400-17 color-new-car">Author:</div>
                                        <div className="d-flex align-items-center text-14-300-17 color-black-olive me-2">
                                            {author_name}
                                        </div>
                                    </>
                                )}

                            </div>

                            {co_authors?.length > 0 && (
                                <>
                                    <div className="text-14-400-17 color-new-car cmb-8">
                                        Co Author:
                                    </div>
                                    <div className="d-flex align-items-center gap-2 flex-wrap cmb-20">
                                        {co_authors
                                            ?.slice()
                                            .sort((a, b) => {
                                                const order = [1, 2, 0];
                                                return order.indexOf(a.co_author_status || 0) - order.indexOf(b.co_author_status || 0);
                                            })
                                            .map((coAuthor, index) => {
                                                const bgClass =
                                                    coAuthor.co_author_status === 1
                                                        ? "bg-a35b color-white"
                                                        : coAuthor.co_author_status === 2
                                                            ? "bg-C991 color-white"
                                                            : "bg-f4ff color-new-car";

                                                return (
                                                    <span
                                                        key={index}
                                                        className={`cps-8 cpe-8 cpt-2 cpb-2 br-2 text-14-400-17 ${bgClass}`}
                                                    >
                                                        {coAuthor?.name}
                                                    </span>
                                                );
                                            })}
                                    </div>
                                </>
                            )}


                            {author_email && (
                                <div className="text-14-300-17 color-black-olive d-flex align-items-center gap-2 cmb-20">
                                    <i className="bi bi-envelope" /> {author_email}
                                </div>
                            )}
                            {whatsapp_number && (
                                <div className="text-14-300-17 color-black-olive d-flex align-items-center gap-2 cmb-20">
                                    <i className="bi bi-whatsapp" />{' '}
                                    {whatsapp_country_code} {whatsapp_number}
                                </div>
                            )}
                            {contact_number && (
                                <div className="text-14-300-17 color-black-olive d-flex align-items-center gap-2 cmb-20">
                                    <i className="bi bi-telephone" />{' '}
                                    {contact_country_code} {contact_number}
                                </div>
                            )}
                            {country_name && (
                                <div className="text-14-300-17 color-black-olive d-flex align-items-center gap-2 cmb-10">
                                    <i className="bi bi-globe-americas" /> {country_name}
                                </div>
                            )}

                            {/* {submitted_from && (
                            <>
                                <div className="text-14-400-17 color-new-car"> Source:</div>
                                <div className="d-flex align-items-center text-14-300-17 color-black-olive me-2">
                                    {submitted_from}
                                </div>
                            </>
                        )} */}
                        </div>


                        {abstractWords &&
                            <>
                                <div className="text-14-400-17 color-new-car">Abstract :</div>
                                <div className="text-14-300-24 color-black-olive">
                                    <div>
                                        {isExpanded ? (
                                            <span
                                                dangerouslySetInnerHTML={{
                                                    __html: abstract,
                                                }}
                                            />
                                        ) : (
                                            <>
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: abstract
                                                            ?.replace(/<\/?p>/g, "")
                                                            ?.replace(/<\/?span[^>]*>/g, "")
                                                            ?.split(" ")
                                                            ?.slice(0, maxWords)
                                                            ?.join(" "),
                                                    }}
                                                />

                                                {abstractWords?.length > maxWords && (
                                                    <>
                                                        {"... "}
                                                        <span
                                                            onClick={toggleReadMore}
                                                            className="text-14-500-23 color-new-car pointer"
                                                        >
                                                            Read More
                                                        </span>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>

                                    {isExpanded && (
                                        <span
                                            onClick={toggleReadMore}
                                            className="text-14-500-23 color-new-car pointer"
                                        >
                                            Read Less
                                        </span>
                                    )}
                                </div>
                            </>}
                    </div>
                </div>
            </Card>

            {co_authors?.length >= 2 && (
                <Card className="cmt-18 cp-20">
                    <div className="row g-4">
                        {co_authors
                            ?.filter(
                                (coAuthor) =>
                                    coAuthor.co_author_status === 1 || coAuthor.co_author_status === 2
                            )
                            ?.slice()
                            .sort((a, b) => a.co_author_status - b.co_author_status)
                            .map((coAuthor, index) => (
                                <div key={index} className="col-12 col-sm-6 col-lg-3">
                                    <div>
                                        <h4 className="text-16-400-20 mb-2">
                                            {coAuthor.co_author_status === 1
                                                ? "Primary Co-Author"
                                                : "Secondary Co-Author"}
                                        </h4>

                                        <div className="mb-2">
                                            <div className="d-flex align-items-center gap-2 mb-2 text-14-300-18">
                                                <i className="bi bi-person" />
                                                <span>{coAuthor?.name}</span>
                                            </div>
                                            <div className="d-flex align-items-center gap-2 mb-2 text-14-300-18">
                                                <i className="bi bi-envelope" />
                                                <span>{coAuthor?.email}</span>
                                            </div>
                                            <div className="d-flex align-items-center gap-2 mb-2 text-14-300-18">
                                                <i className="bi bi-telephone" />
                                                <span>
                                                    {getCountryCode(coAuthor?.country_code)} {coAuthor?.phone}
                                                </span>
                                            </div>
                                            <div className="d-flex align-items-center gap-2 text-14-300-18">
                                                <i className="bi bi-globe-americas" />
                                                <span> {coAuthor?.country_name || "-"}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </div>
                </Card>
            )}



            <div className='cmt-18'>
                <ResearchInformation isView={true} />
            </div>
            <div className='cmt-18'>
                <Card className='cp-20'>
                    {speaker_details?.length > 0 &&
                        <>
                            <div className="text-16-500 color-1717 cmb-10">
                                Relevant Keynote Speakers
                            </div>
                            <div className="border-bottom cmb-20 color-d1d1"></div>
                            <div className='row'>
                                {speaker_details?.map((speaker, index) => (
                                    <div
                                        key={index}
                                        className="col-12 d-flex align-items-center gap-3 flex-grow-1 mb-3"
                                    >
                                        <div className="flex-shrink-0">
                                            <img
                                                src={speaker?.photo || icons.SpeakersIcon}
                                                alt="Speaker"
                                                className="img-fluid rounded-circle"
                                                style={{ width: "40px", height: "40px" }}
                                            />
                                        </div>
                                        <div className="min-w-0">
                                            <div className="text-14-500 color-new-car text-wrap">
                                                {speaker.name}
                                            </div>
                                            <div className="text-12-400 color-6866 text-wrap">
                                                {speaker.speaker_type}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>}


                    <div>
                        {add_on_services?.services?.filter(service => service.isChecked).length > 0 && (
                            <>
                                <div className='cmt-10 text-16-500 color-1717 cmb-10'>
                                    Selected Add-ons
                                </div>
                                <div className="border-bottom cmb-10 color-d1d1"></div>
                                <div className="space-y-2">
                                    {add_on_services?.services
                                        .filter((service) => service.isChecked)
                                        .map((service) => (
                                            <div
                                                key={service.id}
                                                className="d-flex justify-content-between align-items-center cmb-5"
                                            >
                                                <span className="text-16-500-20 color-new-car color-black-olive">
                                                    {service.service_name}
                                                </span>
                                                <span className="text-14-300">Included</span>
                                            </div>
                                        ))}
                                </div>
                                <div className='text-12-400-15 cmt-11'>
                                    * Our team will review your paper & share the pricing with you shortly.
                                </div>
                            </>
                        )}
                    </div>
                    {/* <div className='text-16-500-20 color-new-car cmt-11'>
                            Peer Review Feedback on Abstract
                        </div>
                        <div className='text-12-400-15 cmt-11'>
                            * Our team will review your paper & share the pricing with you shortly.
                        </div> */}
                    <div className="d-flex gap-3 cmt-20">
                        {onBack && (
                            <Button
                                id="btn_review_abstract_back"
                                text="Back"
                                btnStyle="light-outline"
                                className="cps-40 cpe-40 h-38"
                                onClick={onBack}
                                disabled={btnLoading}
                            />
                        )}
                        <Button
                            id="btn_review_abstract_submit"
                            text="Submit"
                            btnStyle="primary-dark"
                            className="cps-40 cpe-40 h-38"
                            onClick={onNext}
                            disabled={btnLoading}
                            btnLoading={btnLoading}
                        />
                    </div>
                </Card>
            </div>

        </>
    )
}

export default ReviewAbstract
